// extracted by mini-css-extract-plugin
export var actionButton = "_p1-0";
export var actionMenuContainer = "_p1-i";
export var bubble = "_p1-2";
export var bubbleActionMenu = "_p1-j";
export var bubbleContext = "_p1-6";
export var bubbleItems = "_p1-7";
export var customer = "_p1-3";
export var divider = "_p1-8";
export var fileList = "_p1-9";
export var hiddenComment = "_p1-o";
export var infoAbove = "_p1-a";
export var internal = "_p1-4";
export var lightActionButton = "_p1-1";
export var link = "_p1-b";
export var merchant = "_p1-5";
export var message = "_p1-c";
export var profilePicture = "_p1-e";
export var quillToolbarContainer = "_p1-f";
export var senderDate = "_p1-g";
export var senderDateCustomer = "_p1-h";
export var senderName = "_p1-d";
export var time = "_p1-k";
export var uploadedImage = "_p1-l";
export var username = "_p1-m";
export var xsmall = "_p1-n";